import { getTimelineData } from '../RightPanel/utils';
import { Timeline } from '@navi/web-ui/lib/primitives';
import { useEffect } from 'react';
import { MOCK_RUN_HISTORY_FETCH_TYPE, MockStatus } from '../../types';
import EmptyState from '../RightPanel/States/EmptyState';
import { CircularLoaderIcon } from '@navi/web-ui/lib/icons';
import { fetchMockRunDetailsByStatus } from '../../actions/FieldAllocationAction';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

const AllocationDetails = () => {
  const dispatch = useDispatch();
  const allocationData = useSelector(
    (state: RootState) => state.fieldAllocation?.previousAllocationDetails
  );
  const isLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.previousAllocationStatusLoading
  );

  useEffect(() => {
    dispatch(
      fetchMockRunDetailsByStatus(MockStatus.ALLOCATED, MOCK_RUN_HISTORY_FETCH_TYPE.LAST_MONTH)
    );
  }, []);

  if (isLoading) {
    return (
      <div className="h-full w-full flex items-center justify-center">
        <CircularLoaderIcon size="lg" />
      </div>
    );
  }

  if (!allocationData?.inputPreparationData) {
    return <EmptyState message="No data found" />;
  }

  //To define min width and max width for timeline
  return (
    <div className="m-5 min-w-[926px] max-w-[1200px]">
      <Timeline data={getTimelineData(allocationData, true)} />
    </div>
  );
};

export default AllocationDetails;
